// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChartWrapper_wrapper__3vmoI","headerWrapper":"ChartWrapper_headerWrapper__2qoDv","icon":"ChartWrapper_icon__2mH3m","chartWrapper":"ChartWrapper_chartWrapper__V14BG"};